/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

    let validate = false;
    function zapisz() {
        localStorage.setItem('validate',
            validate
        );
    }
    let storage = localStorage.getItem( 'validate', validate );
    // console.log(storage);
    if(storage !== 'true'){
        jQuery('#bramka').foundation('open');
    }
    jQuery('#bramka-close').attr("disabled", "disabled");
    // jQuery('#bramka-close').css("display", "none");
    let input = jQuery('#numer');
    input.on("input", function( ) {
        // var dInput = this.value;
        // console.log( input.val(), "Handler for .keypress() called." );
        //czy dlugosc Input jest 7
        if(input.val().length === 7) {
            // console.log('length = 7');
            //czy jest liczba int?
            if(Math.floor(input.val()) == input.val() && jQuery.isNumeric(input.val())) {
                // console.log('yes its an int!');
                let arrStr = input.val().split("");
                // console.log(arrStr);
                let sum = 0;
                for (let i = 1; i <= arrStr.length - 1; i++) {
                    sum = sum + arrStr[i] * i;
                    //console.log('arrStr[' + i + ']: ' + arrStr[i] + ' *' + i + ' = ', arrStr[i] * i);
                    //text += cars[i] + "<br>";
                }
                // console.log(sum);
                let mod = sum % 11;
                if (mod == arrStr[0]) {
                    //$w("#button11").label = "Let's Go!";
                    //$w('#button11').show();
                    // $w('#button11').enable();
                    // console.log('OK');
                    jQuery('#bramka-close').removeAttr("disabled");
                    // jQuery('#bramka-close').css("display", "initial");
                    jQuery('#bramka-close').click(function(){
                        validate = true;
                        zapisz();
                    });
                }
            }
        }else if(input.val().length === 8){
			let arrStr = input.val().split("");
            if (arrStr[7]==='a'||arrStr[7]==='p'||arrStr[7]==='A'||arrStr[7]==='P') {
                jQuery('#bramka-close').removeAttr("disabled");
                // jQuery('#bramka-close').css("display", "initial");
                jQuery('#bramka-close').click(function(){
                    validate = true;
                    zapisz();
                });
            }
        }else if(input.val().length !== 7 && input.val().length !== 8) {
            jQuery('#bramka-close').attr("disabled", "disabled");
        }

    });

});
